(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaede-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupFinder = (root) => {
      if (root.dataset.kaedeFinderReady === 'true') return;
      root.dataset.kaedeFinderReady = 'true';

      let scrollAnchorSpace = 0;
      let scrollAnchorReleaseY = 0;

      const clearScrollAnchorSpace = () => {
        if (!scrollAnchorSpace) return;
        root.style.removeProperty('--kaede-scroll-anchor-space');
        scrollAnchorSpace = 0;
        scrollAnchorReleaseY = 0;
      };

      const updateScrollAnchorSpace = (targetScrollY) => {
        const naturalRootBottom = root.getBoundingClientRect().bottom + window.scrollY - scrollAnchorSpace;
        scrollAnchorReleaseY = Math.max(0, naturalRootBottom - window.innerHeight);
        scrollAnchorSpace = Math.max(0, targetScrollY + window.innerHeight - naturalRootBottom);
        if (scrollAnchorSpace) {
          root.style.setProperty('--kaede-scroll-anchor-space', `${scrollAnchorSpace}px`);
        } else {
          root.style.removeProperty('--kaede-scroll-anchor-space');
        }
      };

      window.addEventListener(
        'scroll',
        () => {
          if (!scrollAnchorSpace) return;
          if (window.scrollY <= scrollAnchorReleaseY) clearScrollAnchorSpace();
        },
        { passive: true },
      );

      root.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        if (!summary) return;

        let anchorTop = null;
        let anchorScrollY = null;

        summary.addEventListener('click', () => {
          anchorTop = details.open ? summary.getBoundingClientRect().top : null;
          anchorScrollY = details.open ? window.scrollY : null;
          if (!details.open) return;
          details.querySelectorAll('details[open]').forEach((child) => {
            child.open = false;
          });
        });

        details.addEventListener('toggle', () => {
          if (details.open) {
            if (scrollAnchorSpace) updateScrollAnchorSpace(window.scrollY);
            return;
          }
          if (anchorTop === null) return;
          updateScrollAnchorSpace(anchorScrollY);
          const delta = summary.getBoundingClientRect().top - anchorTop;
          if (delta) window.scrollBy(0, delta);
          anchorTop = null;
          anchorScrollY = null;
        });
      });

      const newsletterStatus = root.querySelector('[data-newsletter-status]');
      if (newsletterStatus) {
        const newsletterDetails = newsletterStatus.closest('details');
        if (newsletterDetails) newsletterDetails.open = true;
        newsletterStatus.focus();
      }

      const contactStatus = root.querySelector('[data-contact-status]');
      if (contactStatus) {
        const contactDetails = contactStatus.closest('details');
        if (contactDetails) contactDetails.open = true;
        contactStatus.focus();
      }

      const preloadWorkThumbnails = () => {
        const urls = [
          ...new Set(Array.from(root.querySelectorAll('.gallery img'), (image) => image.currentSrc || image.src)),
        ];
        const preloads = new Set();
        let nextIndex = 0;
        let activeCount = 0;

        const loadNext = () => {
          while (activeCount < 2 && nextIndex < urls.length) {
            const image = new Image();
            const url = urls[nextIndex];
            nextIndex += 1;
            activeCount += 1;
            preloads.add(image);
            image.fetchPriority = 'low';
            image.decoding = 'async';

            const finish = () => {
              activeCount -= 1;
              preloads.delete(image);
              loadNext();
            };

            image.addEventListener('load', finish, { once: true });
            image.addEventListener('error', finish, { once: true });
            image.src = url;
          }
        };

        loadNext();
      };

      const scheduleWorkThumbnailPreload = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preloadWorkThumbnails, { timeout: 2000 });
          return;
        }

        window.setTimeout(preloadWorkThumbnails, 0);
      };

      if (document.readyState === 'complete') {
        scheduleWorkThumbnailPreload();
      } else {
        window.addEventListener('load', scheduleWorkThumbnailPreload, { once: true });
      }

      const viewer = root.querySelector('[data-photo-viewer]');
      const viewerImage = root.querySelector('[data-photo-image]');
      const closeButton = root.querySelector('[data-photo-close]');

      if (!viewer || !viewerImage || !closeButton) return;

      const closeViewer = () => {
        if (viewer.open) viewer.close();
      };

      root.querySelectorAll('[data-photo-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const sourceImage = trigger.querySelector('img');
          if (!sourceImage) return;

          viewerImage.src = trigger.dataset.photoSrc || sourceImage.currentSrc || sourceImage.src;
          viewerImage.alt = sourceImage.alt;
          viewerImage.width = Number(trigger.dataset.photoWidth) || sourceImage.naturalWidth || sourceImage.width;
          viewerImage.height = Number(trigger.dataset.photoHeight) || sourceImage.naturalHeight || sourceImage.height;
          viewer.showModal();
          document.body.classList.add('kaede-photo-viewer-open');
        });
      });

      closeButton.addEventListener('click', closeViewer);
      viewer.addEventListener('click', (event) => {
        if (event.target === viewer) closeViewer();
      });
      viewer.addEventListener('close', () => {
        document.body.classList.remove('kaede-photo-viewer-open');
        viewerImage.removeAttribute('src');
        viewerImage.alt = '';
      });
    };

    const setupFinders = (scope = document) => {
      if (scope.matches?.('[data-kaede-finder]')) setupFinder(scope);
      scope.querySelectorAll?.('[data-kaede-finder]').forEach(setupFinder);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupFinders(), { once: true });
    } else {
      setupFinders();
    }

    document.addEventListener('shopify:section:load', (event) => setupFinders(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const finder = event.target.querySelector?.('[data-kaede-finder]');
      finder?.querySelectorAll('[data-editor-content-details]').forEach((details) => {
        details.open = true;
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target;
      if (!(block instanceof Element)) return;
      const finder = block.closest('[data-kaede-finder]');
      if (!finder) return;
      let details = block.closest('details');
      while (details && finder.contains(details)) {
        details.open = true;
        details = details.parentElement?.closest('details');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
